<ng-container *ngIf="hasError">
  <div class="buttons-row">
    <mat-icon>error_outline</mat-icon>
    <p>{{ errorMessage }}</p>
    <button mat-raised-button color="primary" [disabled]="retrying" (click)="emitRetryEvent()">
      <span [style.visibility]="retrying ? 'hidden' : 'visible'">
        {{ 'FRONTEND.SALES_UI.COMMON.ACTION_LABELS.TRY_AGAIN' | translate }}
      </span>
      <div class="spinner-container">
        <mat-spinner *ngIf="retrying" [diameter]="20"></mat-spinner>
      </div>
    </button>
  </div>
</ng-container>
